import { createStyles } from 'antd-style'
import { isNil } from 'lodash'

import { RouterLink } from '@eastcoal/router/components/Link'

import logo from './assets/logo.webp'
import logo2x from './assets/logo@2x.webp'
import { EastcoalLogoProps } from './interface'

const useStyles = createStyles(({ token }) => ({
  logo: {
    width: 168
  },
  logo2x: {
    width: 168 * 1.5
  }
}))

export const EastcoalLogo = ({
  className,
  style,
  large,
  link
}: EastcoalLogoProps) => {
  const { styles } = useStyles()

  const path = isNil(link) ? '' : link

  return (
    <RouterLink className={className} newtab={false} style={style} to={path}>
      <img
        alt='EastcoalLogo'
        className={large ? styles.logo2x : styles.logo}
        src={large ? logo2x : logo}
      />
    </RouterLink>
  )
}
